export const palette = {
	standard: {
		black: '#000',
		white: '#fff',
	},
	black: {
		100: '#727479',
		200: '#67696d',
		300: '#53565c',
		400: '#44484e',
		500: '#383b40',
		600: '#2d2f34',
		700: '#27292d',
		800: '#1f2023',
		900: '#010101',
	},
	darkBlue: {
		100: '#717d92',
		200: '#627088',
		300: '#596780',
		400: '#4e5d78',
		500: '#455571',
		600: '#364766',
		700: '#223659',
		800: '#001945',
		900: '#00163e',
	},
	red: {
		100: '#fee7e6',
		200: '#fdc2bf',
		300: '#ffc4c4',
		400: '#ff4d4d',
		500: '#ff0000',
		600: '#f30000',
		700: '#e50000',
		800: '#de0000',
		900: '#d80000',
	},
	gray: {
		100: '#fafbfb',
		200: '#f7f8f9',
		300: '#f1f2f4',
		400: '#e1e4e8',
		500: '#c9ced6',
		600: '#b0b7c3',
		700: '#a7aebb',
		800: '#98a1b1',
		900: '#8a94a6',
	},
	blue: {
		100: '#e0f6ff',
		200: '#c4edff',
		300: '#80d8ff',
		400: '#26bdff',
		500: '#00b1ff',
		600: '#00aaff',
		700: '#00a1ff',
		800: '#0098ff',
		900: '#0088ff',
	},
	green: {
		100: '#f2fff2',
		200: '#e0f5e0',
		300: '#b3e7b3',
		400: '#80d780',
		500: '#4dc64d',
		600: '#26ba26',
		700: '#00ae00',
		800: '#009500',
		900: '#007b00',
	},
	orange: {
		100: '#fffcf5',
		200: '#fff6e4',
		300: '#ffecc7',
		400: '#ffdc99',
		500: '#ffca65',
		600: '#ffbb38',
		700: '#ff9b00',
		800: '#ff8f00',
		900: '#f07300',
	},
	purple: {
		100: '#faf0ff',
		200: '#f3dcff',
		300: '#e6b5ff',
		400: '#c980ee',
		500: '#b34de7',
		600: '#a226e1',
		700: '#9200dc',
		800: '#8500c8',
		900: '#7800b5',
	},
};
